import { Form } from "@themesberg/react-bootstrap";
import React from "react";

export const Textbox = ({
  Label,
  name,
  Type = "text",
  Placeholder = "",
  register,
  errors,
  validationRules,
  watch,
  disabled = false,
  ...rest
}) => {
  const value = watch(name);
  const isRequired = validationRules?.required;
  return (
    <>
      {Label ? (
        <Form.Label className="mb-0">
          {Label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </Form.Label>
      ) : (
        ""
      )}
      <Form.Control
        disabled={disabled}
        className="shadow-none"
        isInvalid={!!errors[name]}
        isValid={!errors[name] && value}
        placeholder={Placeholder}
        type={Type}
        {...register(name, validationRules)}
        {...rest}
      />
      {errors[name] && (
        <Form.Control.Feedback type="invalid">
          {errors[name].message}
        </Form.Control.Feedback>
      )}
    </>
  );
};
